export default __webpack_public_path__ + "static/example-e8f7654e26fc577d9b461d7cd9096768.mp4";